import { Action } from '@ngrx/store';
import { NotificationTemplateModel, ParameterModel } from './model';

export enum ActionTypes {
  FAILURE = '[NotificationTemplate] Failure',

  LOAD_REQUEST = '[NotificationTemplate] Load Request',
  LOAD_SUCCESS = '[NotificationTemplate] Load Success',

  SAVE_REQUEST = '[NotificationTemplate] Save Request',
  SAVE_SUCCESS = '[NotificationTemplate] Save Success',

  SET_SELECTED_REQUEST = '[NotificationTemplate] Set Selected Request',
  SET_SELECTED_SUCCESS = '[NotificationTemplate] Set Selected Success',

  LOAD_PARAMETERS_REQUEST = '[NotificationTemplate] Load Parameters Request',
  LOAD_PARAMETERS_SUCCESS = '[NotificationTemplate] Load Parameters Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}
export class LoadRequestAction implements Action {
  readonly type = ActionTypes.LOAD_REQUEST;
}

export class LoadSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_SUCCESS;
  constructor(public templates: NotificationTemplateModel[]) {}
}

export class SaveRequestAction implements Action {
  readonly type = ActionTypes.SAVE_REQUEST;

  constructor(public template: NotificationTemplateModel) {}
}

export class SaveSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_SUCCESS;

  constructor(public template: NotificationTemplateModel) {}
}

export class SetSelectedRequestAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_REQUEST;

  constructor(public id: number) {}
}

export class SetSelectedSuccessAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_SUCCESS;

  constructor(public template: NotificationTemplateModel) {}
}

export class LoadParametersRequestAction implements Action {
  readonly type = ActionTypes.LOAD_PARAMETERS_REQUEST;

  constructor() {}
}

export class LoadParametersSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_PARAMETERS_SUCCESS;

  constructor(public parameters: ParameterModel[]) {}
}

export type Actions =
  | FailureAction
  | LoadRequestAction
  | LoadSuccessAction
  | SaveRequestAction
  | SaveSuccessAction
  | SetSelectedRequestAction
  | SetSelectedSuccessAction
  | LoadParametersRequestAction
  | LoadParametersSuccessAction;
